export const getKnowledgeBasesUrl = (workspaceId: string) => `/business/workspaces/${workspaceId}/knowledgebases`;

export const getKnowledgeBaseUrl = (workspaceId: string, id: string) =>
  `/business/workspaces/${workspaceId}/knowledgebases/${id}`;

export const getCloneKnowledgeBaseUrl = (workspaceId: string, id: number) =>
  `/business/workspaces/${workspaceId}/knowledgebases/${id}/clone`;

export const getDataSetsUrls = (workspaceId: string, knowledgeBaseId: string) =>
  `/business/workspaces/${workspaceId}/knowledgebases/${knowledgeBaseId}/datasets`;

export const getDataSetUrls = (workspaceId: string, knowledgeBaseId: string, id: string) =>
  `/business/workspaces/${workspaceId}/knowledgebases/${knowledgeBaseId}/datasets/${id}`;

export const getCancelDataSetUrls = (workspaceId: string, knowledgeBaseId: string, id: string) =>
  `/business/workspaces/${workspaceId}/knowledgebases/${knowledgeBaseId}/datasets/${id}/cancel`;

export const getRestartDataSetUrls = (workspaceId: string, knowledgeBaseId: string, id: string) =>
  `/business/workspaces/${workspaceId}/knowledgebases/${knowledgeBaseId}/datasets/${id}/restart`;

export const getKnowledgeBaseParserUrl = () => 'business/available_kb_parsers';

export const getRetrieveChunkUrl = (workspaceId: string, knowledgeBaseId: string) =>
  `business/workspaces/${workspaceId}/knowledgebases/${knowledgeBaseId}/retrieve_chunk`;

export const getChunksUrls = (workspaceId: string, knowledgeBaseId: string, datasetId: string) =>
  `/business/workspaces/${workspaceId}/knowledgebases/${knowledgeBaseId}/datasets/${datasetId}/chunks`;

export const getChunkUrls = (workspaceId: string, knowledgeBaseId: string, datasetId: string, chunkId: string) =>
  `/business/workspaces/${workspaceId}/knowledgebases/${knowledgeBaseId}/datasets/${datasetId}/chunks/${chunkId}`;
